import { VariableNames } from "../../../../UserInterfaceModule/Constants/VariableNames";
import { CollectionSortExpression } from "../../../Models/Collections/CollectionSortExpression";
import { IExpressionEvaluator, IHasExpressionMetadata } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";

export class CollectionSortExpressionEvaluator implements IExpressionEvaluator<CollectionSortExpression>, IHasExpressionMetadata {
    private static _expressionPropertyNames: string[] = ["Collection"];

    get expressionProperties(): string[] {
        return CollectionSortExpressionEvaluator._expressionPropertyNames;
    }

    get type(): string {
        return "CollectionSort";
    }

    evaluate(expression: CollectionSortExpression, context: IExpressionEvaluatorContext): MaybePromise {
        const collection = context.Evaluator.evaluate(expression.Collection, context);

        if (collection instanceof Promise) {
            return collection.then((resolvedCollection) => this.sortCollection(resolvedCollection, expression, context));
        }

        return this.sortCollection(collection, expression, context);
    }

    private sortCollection(collection: any[], expression: CollectionSortExpression, context: IExpressionEvaluatorContext): MaybePromise {
        if (!Array.isArray(collection)) {
            return [];
        }

        const sortKeys: any[] = [];
        let hasPromise = false;

        const childContext = context.CreateChild();
        for (const item of collection) {
            childContext.VariableScope.set(VariableNames.Item, item);

            const sortKey = context.Evaluator.evaluate(expression.SortBy, childContext);
            sortKeys.push(sortKey);
            if (sortKey instanceof Promise) {
                hasPromise = true;
            }
        }

        if (hasPromise) {
            return Promise.all(sortKeys).then((resolvedKeys) => this.buildSortedArray(collection, resolvedKeys, expression.SortDescending));
        }

        return this.buildSortedArray(collection, sortKeys, expression.SortDescending);
    }

    private buildSortedArray(items: any[], sortKeys: any[], descending?: boolean): any[] {
        const indexed = items.map((item, i) => ({ item, key: sortKeys[i] }));

        indexed.sort((a, b) => compareKeys(a.key, b.key, !!descending));

        return indexed.map((x) => x.item);
    }
}

function compareKeys(a: any, b: any, descending: boolean): number {
    if (a < b) return descending ? 1 : -1;
    if (a > b) return descending ? -1 : 1;
    return 0;
}
